import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@material-ui/core";

function KeyItem(props) {
  const { t } = useTranslation("translation");

  const renderButtonText = () => {
    if (props.alphabet === "Clear") {
      return t("Clear");
    } else if (props.alphabet === "Enter") {
      return t("Enter");
    } else {
      return props.alphabet;
    }
  };

  return (
    <div
      id="keyItemContainer"
      className={props.idVal === "Enter" ? "keyItemEnter" : "keyItemDefault"}
      style={{
        marginLeft: props.marginLeft,
      }}
    >
      <Box
        id={props.idVal}
        onClick={() => props.onClick(props.idVal, props.alphabet)}
      >
        {!props.image && renderButtonText()}
        {props.image && (
          <img
            id={props.idVal}
            className="keyItemImage"
            src={props.image}
            alt={props.idVal}
          />
        )}
      </Box>
    </div>
  );
}

export default KeyItem;
